import { Button, PageHeader } from 'components';
import { Row, Col, Table, Checkbox } from 'antd';
import styles from './style.module.scss';
import { CheckOutlined } from '@ant-design/icons';
import { useTranslation } from 'react-i18next';
import useEditInvoices from './useEditInvoices';
import useUser from 'hooks/useUser';

const Edit = ({ isNew }) => {
  const { user } = useUser();
  const isAdmin = user?.user?.superadmin || user?.user?.master_admin;
  const {
    data,
    columns,
    tableSummary,
    onUpdate,
    updateInProcess,
    comment,
    setComment,
    handleAcceptOrRefuse,
    approveRejectInProcess,
    singleItem,
    isWeekClosed,
    setIsWeekClosed,
    initialWeekClosed
  } = useEditInvoices();


  const { t } = useTranslation();
  const title = isNew ? t('PUBBLICA DOCUMENTO') : t('MODIFICA DATI');

  return (
    <div>
      <PageHeader title={title}>
      <Checkbox
          name='week_closed'
          checked={isWeekClosed}
          onChange={() => setIsWeekClosed(!isWeekClosed)}
          disabled={initialWeekClosed && !isAdmin}
        >
          {t('Chiudere la settimana')}
        </Checkbox>
        <Row gutter={16}>
          <Col>
            <Button
              onClick={onUpdate}
              width={'150px'}
              big
              icon={<CheckOutlined />}
              loading={updateInProcess}
            >
              {t('Invia')}
            </Button>
          </Col>
        </Row>
      </PageHeader>
      <div className={styles.content}>
        <Table
          columns={columns}
          dataSource={data}
          pagination={false}
          size='small'
          summary={tableSummary}
          rowKey='id'
          rowClassName={(row) =>
            row.outOfCompanyPeriod ? styles.disabledRow : ''
          }
          loading={updateInProcess}
          scroll={{ x: 1000 }}
        />
      </div>

      {(singleItem?.allData?.can_approve || isAdmin) && (
        <div style={{ marginTop: 16, padding: '24px' }}>
          <textarea
            placeholder={t('Inserisci notifica per il richiedente')}
            onChange={(e) => setComment(e.target.value)}
            value={comment}
            style={{ width: '100%', height: '150px', padding: '14px' }}
            disabled={!initialWeekClosed}
          />
          <Row gutter={14} justify='start' style={{ marginTop: '16px' }}>
            <Col>
              <Button
                onClick={() =>
                  handleAcceptOrRefuse({
                    status: 'Approva',
                    description: comment,
                  })
                }
                disabled={approveRejectInProcess || !initialWeekClosed} 
              >
                {t('Approva')}
              </Button>
            </Col>
            <Col>
              <Button
                type={'red'}
                onClick={() =>
                  handleAcceptOrRefuse({
                    status: 'Rifiutato',
                    description: comment,
                  })
                }
                disabled={approveRejectInProcess || !initialWeekClosed}
              >
                {t('Rifiutato')}
              </Button>
            </Col>
          </Row>
        </div>
      )}
      
    </div>
  );
};

export default Edit;
